export const apiBaseUrl = "https://simulanis-videos.azurewebsites.net/"
export const ImageBaseUrl = "https://simulanis-videos.azurewebsites.net/"

// export const apiBaseUrl = "http://localhost:4001"
// export const ImageBaseUrl = "http://localhost:4001/"